import {
  Component,
  ViewChild,
  EventEmitter,
  Output,
  TemplateRef,
  ViewContainerRef,
  inject,
} from '@angular/core';
import { Router } from '@angular/router';
import { RefreshGridService } from '../../../../../../shared/services/refresh-grid.service'; // Import the shared service
import { EngagementService } from '../../../../../../services/engagement.service';
import { GridModule } from '@progress/kendo-angular-grid';
import { ChartsModule } from '@progress/kendo-angular-charts';
import { InputsModule, SliderModule } from '@progress/kendo-angular-inputs';
import {
  KENDO_LAYOUT,
  LayoutModule,
} from '@progress/kendo-angular-layout';
import { ScrollViewModule } from '@progress/kendo-angular-scrollview';
import {
  KENDO_ICONS,
  IconsModule,
  SVGIcon,
} from '@progress/kendo-angular-icons';
import { KENDO_BUTTONS, ButtonsModule } from '@progress/kendo-angular-buttons';
import { LabelModule } from '@progress/kendo-angular-label';
import { AutoCompleteComponent, DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { ListViewModule } from '@progress/kendo-angular-listview';
import { GaugesModule } from '@progress/kendo-angular-gauges';
import { IntlModule } from '@progress/kendo-angular-intl';
import { PopupService, PopupRef } from '@progress/kendo-angular-popup'
import {
  searchIcon,
  playIcon,
} from '@progress/kendo-svg-icons';

import { Input } from '@angular/core';
import { PopupModule, Align, AnimationDirection, AnimationType, PopupAnimation } from '@progress/kendo-angular-popup';
import {
  FormBuilder, FormGroup, Validators, FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { ShownotificationService } from '../../../../../../services/shownotification.service';
import { AuthService } from '../../../../../../shared/auth/auth.service';
import { EngagementrequestService } from '../../../../../../services/engagementrequest.service';
import { Roles } from '../../../../../../constants/roles';
import { AuthUserService } from '../../../../../../shared/auth/auth-user.service';
import { KENDO_INDICATORS } from '@progress/kendo-angular-indicators';
import { NgxSpinnerModule } from "ngx-spinner";
import { NgxSpinnerService } from "ngx-spinner";
import { debounceTime, distinctUntilChanged, filter } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { KENDO_TOOLTIPS } from "@progress/kendo-angular-tooltip";

@Component({
  selector: 'app-engagementrequest',
  standalone: true,
  templateUrl: './engagementrequest.component.html',
  styleUrl: './engagementrequest.component.scss',
  imports: [
    KENDO_LAYOUT,
    KENDO_ICONS,
    KENDO_BUTTONS,
    KENDO_INDICATORS,
    GridModule,
    ChartsModule,
    InputsModule,
    SliderModule,
    LayoutModule,
    ScrollViewModule,
    IconsModule,
    ButtonsModule,
    LabelModule,
    DropDownsModule,
    ListViewModule,
    FormsModule,
    ReactiveFormsModule,
    GaugesModule,
    IntlModule,
    PopupModule,
    NgxSpinnerModule,
    KENDO_TOOLTIPS
],
})
export class EngagementrequestComponent {
  @Input() openRequestEngagementPopup!: boolean;
  @Input() anchor!: any;
  @Input() public margin: any;// = { horizontal: -30, vertical: -75 };
  @Output() closeEvent = new EventEmitter<void>();
  loggedInUserRole: string = "";
  userRoles = Roles;
  isDisplayloader: boolean = false;
  isDisplayloaderSearch: boolean = false;
  @ViewChild('popupContent') popupContent!: TemplateRef<any>;
  //@ViewChild('popupContent') popupContent!:ViewContainerRef;

  // @ViewChild('popupContent', { static: true }) popupContent!: TemplateRef<any>;
  private popupRef: PopupRef | undefined;

  @ViewChild("autocomplete", { static: false })
  public autocomplete!: AutoCompleteComponent;

  public searchIcon: SVGIcon = searchIcon;
  public playIcon: SVGIcon = playIcon;

  public engagementRequestDetailsForm!: FormGroup;
  public enabled = true;
  public duration = 200;
  public type: AnimationType = "slide";
  public direction: AnimationDirection = "left";


  public anchorAlign: Align = { horizontal: "right", vertical: "top" };
  public popupAlign: Align = { horizontal: "right", vertical: "top" };

  public get animate(): boolean | PopupAnimation {
    if (this.enabled) {
      return {
        type: this.type,
        direction: this.direction,
        duration: this.duration,
      };
    }
    return false;
  }


  public isSearchSelected: boolean = true;
  public searchText: string = "";
  public userProfile: any;
  public selectedEngagementDetail: any;
  public selectedEngagementNumber: string = "";
  public searchedEngagementDetails: any[] = [];
  public isAutoApprove: boolean = false;
  public errorMessage: string = "";
  private searchSubject = new Subject<string>();

  private readonly popupService = inject(PopupService);
  private readonly engagementService = inject(EngagementService);
  private readonly engagementrequestService = inject(EngagementrequestService);
  private readonly authService = inject(AuthService);
  private readonly router = inject(Router);
  private readonly fb = inject(FormBuilder);
  private readonly shownotificationService = inject(ShownotificationService);
  private readonly viewContainerRef = inject(ViewContainerRef);
  private readonly refreshGridService = inject(RefreshGridService);
  private readonly authUserService = inject(AuthUserService);
  private spinner = inject(NgxSpinnerService);

  ngOnInit(): void {
    if (!localStorage.getItem('loggedInUserRole')) {
      this.authUserService.loggedInUserProfile.subscribe(userRole => {
        this.loggedInUserRole = userRole;
      })
    }
    else
      this.loggedInUserRole = localStorage.getItem('loggedInUserRole') ?? "";

    this.createEngagementRequestDetailsForm();
    this.userProfile = JSON.parse(localStorage.getItem('userProfile') ?? "");

    //event to call searchEngagementDetailsListsByEngagementNameOrNumber after 3 characters, 1 second debounce, only after value changes
    this.searchSubject
    .pipe(
      debounceTime(1000),
      filter(value => value.length >= 3)
    )
    .subscribe(value => {
      this.searchEngagementDetailsListsByEngagementNameOrNumber(value);
    });
  }

  public open(): void {
    this.openRequestEngagementPopup = true;
    this.resetEngagementRequestDetailsForm();

  }

  public close(): void {
    this.openRequestEngagementPopup = false;
    this.closeEvent.emit();
    this.resetEngagementRequestDetailsForm();
    this.isSearchSelected = true;
    this.searchText = "";
    this.isAutoApprove = false;
    this.errorMessage = "";
    this.searchedEngagementDetails = [];
  }

  onSearchInputChange(value: string) {
    this.searchSubject.next(value);
    if(value.length==0){
    this.selectedEngagementNumber = '';
    }
  }

  // Search ..
  public searchEngagementDetailsListsByEngagementNameOrNumber(value: any): void {
    this.selectedEngagementNumber = '';
    this.errorMessage = "";
    this.isDisplayloaderSearch = true;
    this.spinner.show();
    this.searchedEngagementDetails = [];
    this.searchText = value;
    this.isSearchSelected = true;
    this.engagementrequestService
      .searchEngagementDetailsListsByEngagementNameOrNumber(value)
      .subscribe({
        next: (x) => {
          this.searchedEngagementDetails = x.data;
          this.isDisplayloaderSearch = false;
          this.spinner.hide();
        },
        error: (x) => {
          this.isDisplayloaderSearch = false;
          this.spinner.hide();
        }
      });
  }

  // Play Button
  public getEngagementDetailsByEngagementNameOrNumber(): void {
    this.isSearchSelected = false;
    this.errorMessage = "";
    this.selectedEngagementDetail = this.searchedEngagementDetails.find(e =>
      e.engagementNumber === this.selectedEngagementNumber);

    if (!this.selectedEngagementNumber || (this.searchedEngagementDetails.length == 0)) {
      this.errorMessage = "Enter some engagement code / number in Search textbox field and click on Submit button.";
      this.isSearchSelected = true;
    }

    if (this.loggedInUserRole !== this.userRoles.SupportUserRole) {
      this.isAutoApprove = (this.selectedEngagementDetail.engagementPartnerEmailAddress === this.userProfile.email)
        || (this.selectedEngagementDetail.EngagementManagerEmailAddress === this.userProfile.email);
    }

    this.selectedEngagementDetail.engagementClosedDate =
      this.selectedEngagementDetail.engagementClosedDate <= this.selectedEngagementDetail.engagementCreatedDate ?
        null : this.selectedEngagementDetail.engagementClosedDate;

    this.engagementRequestDetailsForm.setValue({
      ClientCode: this.selectedEngagementDetail.clientCode,
      ClientName: this.selectedEngagementDetail.clientName,
      EngagementNumber: this.selectedEngagementDetail.engagementNumber,
      EngagementName: this.selectedEngagementDetail.engagementName,
      EngagementType: this.selectedEngagementDetail.engagementType,
      EngagementCreatedDate: this.selectedEngagementDetail.engagementCreatedDate,
      EngagementClosedDate: this.selectedEngagementDetail.engagementClosedDate,
      EngagementStatus: this.selectedEngagementDetail.engagementStatus,
      ProfitCenterCode: this.selectedEngagementDetail.profitCenterCode,
      ProfitCenterDescription: this.selectedEngagementDetail.profitCenterDescription,
      Function: this.selectedEngagementDetail.function,
      FunctionDescription: this.selectedEngagementDetail.functionDescription,
      // Area { get; set; }
      ServiceGroup: this.selectedEngagementDetail.serviceGroup,
      ServiceGroupDescription: this.selectedEngagementDetail.serviceGroupDescription,
      ServiceLine: this.selectedEngagementDetail.serviceLine,
      ServiceLineDescription: this.selectedEngagementDetail.serviceLineDescription,
      ServiceNetworkCode: this.selectedEngagementDetail.serviceNetworkCode,
      ServiceNetworkDescription: this.selectedEngagementDetail.serviceNetworkDescription,
      LineOfBusiness: this.selectedEngagementDetail.lineOfBusiness,
      EngagementPartnerName: this.selectedEngagementDetail.engagementPartnerName,
      EngagementPartnerEmailAddress: this.selectedEngagementDetail.engagementPartnerEmailAddress,
      EngagementManagerName: this.selectedEngagementDetail.engagementManagerName,
      EngagementManagerEmailAddress: this.selectedEngagementDetail.engagementManagerEmailAddress,
      MatchedColumns: this.selectedEngagementDetail.matchedColumns,
      RequestUserId: this.userProfile.id,
      RequestUserEmail: this.userProfile.email,
      RequestUserComment: "",
      ApprovalUserId: this.isAutoApprove ? this.userProfile.id : null,
      ApprovalUserEmail: this.isAutoApprove ? this.userProfile.email : null,
      ApprovalUserComment: "",

    });
  }

  public onSelectedEngagement(engagementNumber: string) {
    this.selectedEngagementNumber = engagementNumber;
    let searchedEngagement = this.searchedEngagementDetails.find(e =>
      e.engagementNumber === this.selectedEngagementNumber);
    this.searchText = searchedEngagement.engagementNumber + ' ' + searchedEngagement.engagementName;
  }

  public createEngagementRequestDetailsForm(): void {
    this.engagementRequestDetailsForm = this.fb.group({
      ClientCode: [null, Validators.required],
      ClientName: [null, Validators.required],
      EngagementNumber: [null, Validators.required],
      EngagementName: [null, Validators.required],
      EngagementType: [null, Validators.required],
      EngagementCreatedDate: [null, Validators.required],
      EngagementClosedDate: [null],
      EngagementStatus: [null, Validators.required],
      ProfitCenterCode: [null],
      ProfitCenterDescription: [null, Validators.required],
      Function: [null],
      FunctionDescription: [null],
      // Area { get; set; }
      ServiceGroup: [null],
      ServiceGroupDescription: [null],
      ServiceLine: [null],
      ServiceLineDescription: [null],
      ServiceNetworkCode: [null],
      ServiceNetworkDescription: [null],
      LineOfBusiness: [null, Validators.required],
      EngagementPartnerName: [null],
      EngagementPartnerEmailAddress: [null],
      EngagementManagerName: [null],
      EngagementManagerEmailAddress: [null],
      MatchedColumns: [null],
      RequestUserId: [null, Validators.required],
      RequestUserEmail: [null],
      RequestUserComment: [null],
      ApprovalUserId: [null],
      ApprovalUserEmail: [null],
      ApprovalUserComment: [null],
    });
  }

  public handleKeydown = (event: KeyboardEvent) => {
    if (event.key === 'Escape') {
      this.close();
    }
  }


  public resetEngagementRequestDetailsForm(): void {
    //  this.name = '';
    //  this.accountId = '';
    //  if (this.form) {
    //    this.form.resetForm();
    //  }
  }

  public createEngagementRequestDetails(): void {
    let clientCode = this.engagementRequestDetailsForm?.value.ClientCode;
    let clientName = this.engagementRequestDetailsForm?.value.ClientName;
    this.isDisplayloader = true;
    this.spinner.show();
    //if (this.engagementRequestDetailsForm.valid) {
    // If ClientCode and CliendName is empty then no need to save request
    if (clientCode && clientName) {
      // if(((clientCode !==null || clientCode !=="") &&  (clientName!==null || clientName !==""))){
      this.engagementrequestService.createEngagementRequestDetails(this.engagementRequestDetailsForm.value, this.isAutoApprove).subscribe({
        next: () => {

          if (!this.isAutoApprove) {
            this.isDisplayloader = false;
            this.spinner.hide();
            this.shownotificationService.showNotification('success');
            this.router.navigate([
              '/RequestEngagementSuccess',
              this.selectedEngagementDetail.engagementName
            ]);
          }
          if (this.isAutoApprove) {
            this.isDisplayloader = false;
            this.spinner.hide();
            this.shownotificationService.showNotification('successEnagagementSaveAndApprovetState');
            this.refreshGridService.refreshRequestGrid.next(true);
            if (this.router.url !== '/request') {
              this.router.navigate([
                '/Request'
              ]);
            }
          }

          this.close();

        },
        error: (error) => {
          this.close();
          var errorResult = JSON.parse(error.error);
          if (errorResult.StatusCode == "500") {
            this.shownotificationService.showNotification(errorResult.StatusCode, errorResult.StatusCode + ":Internal Server Error")
          }
          else if (errorResult.StatusCode == "503") {
            this.shownotificationService.showNotification(errorResult.StatusCode, errorResult.StatusCode + ":Service Unavailable")
          }
          else {
            this.shownotificationService.showNotification('engagementRequestAlreadyExistError', errorResult.ErrorMessage);
          }
          this.isDisplayloader = false;
          this.spinner.hide();
        }
      })
    } // If ClientCode and CliendName is empty
    else {
      this.close();
      //fix the issue: empty screen on 2nd time engagement request.
      this.isSearchSelected = false;
      this.isDisplayloader = false;
      this.spinner.hide();
      //fix the issue: empty screen on 2nd time engagement request.
      this.shownotificationService.showNotification('engagementRequestError');
    }

  }

  public cancelEngagementRequestDetails(): void {
    this.close();

  }

  public onFilter(value: Event): void {
    const inputValue = value;
  }

}
